import { render, staticRenderFns } from "./PBFooter.vue?vue&type=template&id=57bedfec&scoped=true&"
import script from "./PBFooter.vue?vue&type=script&lang=js&"
export * from "./PBFooter.vue?vue&type=script&lang=js&"
import style0 from "./PBFooter.vue?vue&type=style&index=0&id=57bedfec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bedfec",
  null
  
)

export default component.exports